<template>
  <div class="" v-if="app.cities">
    <p class="mb-2 text-lg font-bold">{{ $t('fat.location.headingPopular') }}</p>
    <div class="grid grid-cols-3 gap-2">
      <div v-for="city in app.cities.slice(0, 3)" :key="city.id">
        <div class="rounded-md bg-mist text-center overflow-hidden transition-all hover:bg-coral hover:text-white group" :class="{ '!bg-coral !text-white': fat.cityId === city.id && (!fat.location || !route.name.startsWith('fat')) }">
          <div class="relative flex flex-col justify-center cursor-pointer h-32 py-3" @click="updateCityId(city.id)">
            <div class="relative z-20">
              <div class="text-2xl my-2 text-coral transition-all group-hover:text-white" :class="{ '!text-white': fat.cityId === city.id && (!fat.location || !route.name.startsWith('fat')) }">
                <AtomIcon name="location-dot" />
              </div>
              <div class="font-medium text-lg" v-html="city.restaurants" />
              <div class="font-medium text-sm" v-html="city.name" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()
const app = useAppStore()
const fat = useFatStore()

// Update City ID
const updateCityId = (cityId) => {
  const city = useCityById(cityId)
  const reRoutePages = [
    'restaurants', 
    'restaurants-city', 
    'restaurants-city-tag', 
    'events', 
    'events-city',
    'events-city-tag',
    'offers', 
    'offers-city',
    'giftcards', 
    'giftcards-city',
  ]
  
  const cityRouteName = route.name.split('-')[0] + '-city'
  const baseSlug = route.path.split('/')[1] ?? null
  const category = app.categories.find(cat => cat.slug === baseSlug)
 
  if (route.name.startsWith('fat') || route.name === 'res-req') {
    // console.log('FAT || ResREq')
    fat.cityId = parseInt(cityId)

    return navigateTo({
      query: {
        ...route.query,
        cityId: cityId,
        drawer: undefined,
        location: undefined,
        locationModal: undefined
      }
    })
  } else if (city && reRoutePages.includes(route.name)) {
    // console.log('reRoutePages')
    fat.cityId = parseInt(cityId)

    return navigateTo({
      name: cityRouteName,
      params: {
        city: useSlugify(city.name)
      },
      query: {
        ...route.query,
        drawer: undefined,
        location: undefined,
        locationModal: undefined
      }
    })
  } else {
    // console.log('else')
    fat.cityId = parseInt(cityId)
    
    return navigateTo({ 
      path: `/${city.slug}`,
      query: {
        ...route.query,
        drawer: undefined,
        location: undefined,
        locationModal: undefined
      }
    })
  }

  /*
  if (city && route.name === 'all' && category?.slug) {
    return navigateTo({ path: `/${baseSlug}/${city.slug}` })
  } else if (city && reRoutePages.includes(route.name)) {
    // fat.cityId = parseInt(cityId)
    
    return navigateTo({
      name: cityRouteName,
      params: {
        city: useSlugify(city.name)
      },
      query: {
        ...route.query,
        location: undefined,
        locationModal: undefined
      }
    })
  } else if (route.name.startsWith('fat')) {
    useUpdateQuery({ cityId: cityId, location: undefined, locationModal: undefined })
  } else {
    fat.cityId = parseInt(cityId)
    useUpdateQuery({ locationModal: undefined })
  }
  */
}
</script>

<style lang="scss" scoped>
// 
</style>